import axios from './axiosConfig';

export interface ZabbixDataSource {
  id: number;
  name: string;
  baseUrl: string;
  username: string;
  tenantId?: number;
  isPlatform: boolean;
  status: string;
  hasToken: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ZabbixDataSourcePayload {
  name: string;
  baseUrl: string;
  username: string;
  password: string;
  isPlatform: boolean;
  status: string;
}

export const getZabbixDataSources = async (): Promise<ZabbixDataSource[]> => {
  const response = await axios.get('/api/zabbix/data-sources');
  return response.data;
};

export const createZabbixDataSource = async (
  payload: ZabbixDataSourcePayload
): Promise<ZabbixDataSource> => {
  const response = await axios.post('/api/zabbix/data-sources', payload);
  return response.data;
};

export const updateZabbixDataSource = async (
  id: number,
  payload: ZabbixDataSourcePayload
): Promise<ZabbixDataSource> => {
  const response = await axios.put(`/api/zabbix/data-sources/${id}`, payload);
  return response.data;
};

export const deleteZabbixDataSource = async (id: number): Promise<void> => {
  await axios.delete(`/api/zabbix/data-sources/${id}`);
};

export const testZabbixDataSource = async (id: number): Promise<any> => {
  const response = await axios.post(`/api/zabbix/data-sources/${id}/test`);
  return response.data;
};